import { type QueryStatus, useQuery } from '@tanstack/react-query';
import { ServiceFactory } from '../../services/ServiceFactory';

const productService = ServiceFactory.createProductService();

type Params = {
  productKey: string;
  quantity?: number;
  centAmount?: number;
  customerGroupId?: string;
};

type Amount = {
  centAmount: number;
};

type UseProductPrices = {
  data?: {
    discountAmount: Amount;
    discountValue: {
      percentage: number;
      type: 'relative';
    }
    tags: string[];
  }[];
  status: QueryStatus,
};

/**
 * Hook for fetching the discount of a product
 */
export const useProductDiscounts = (params: Params, enabled: boolean = false): UseProductPrices => {
  const getProductDiscountQuery = useQuery({
    queryKey: ['productDiscounts', ...Object.entries(params)],
    queryFn: () => productService.getProductDiscount(params),
    enabled,
    placeholderData: (previousData) => previousData,
  });

  return {
    data: getProductDiscountQuery.data,
    status: getProductDiscountQuery.status,
  };
};
